export const CoachChallengeDecision = {
  name: "coach-challenge-decision",
  component: "MainPanel",
  layout: "main-panel large",
  mode: "visible",
  text: "coach-challenge.decision",
  showOn: [
    {
      state: "primary",
      value: "coach-challenge-decision",
      operator: "is",
    },
  ],
  allowCancel: true,
  children: [
    {
      name: "coach-challenge-decision-types",
      component: "ButtonGroup",
      layout: "button-group",
      mode: "visible",
      showOn: [true],
      options: {
        value: "singleOption",
        optionName: "decision",
        layout: "type-button",
        prefix: "decision",
        children: ["upheld", "overturned"],
      },
      actionGroups: [
        {
          actions: [
            {
              action: "saveData",
              value: [{ option: "status", value: "COMPLETE" }],
              type: "options",
            },
            { action: "sendEvent", value: "edit", type: "main" },
            { action: "processInserts", value: "all", type: "inserts" },
            {
              action: "nextState",
              value: null,
              type: "primary",
            },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
